import { useState, useEffect } from 'react';
import api from '../api';

const emptyGroup = { name: '', note: '' };

export default function ProductEquivalencies() {
  const [groups, setGroups] = useState([]);
  const [products, setProducts] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState(emptyGroup);
  const [addMemberProduct, setAddMemberProduct] = useState({});

  const fetchGroups = async () => {
    const res = await api.get('/api/bom/equivalency-groups');
    setGroups(res.data);
  };

  const fetchProducts = async () => {
    const res = await api.get('/api/products/');
    setProducts(res.data);
  };

  useEffect(() => {
    fetchGroups();
    fetchProducts();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post('/api/bom/equivalency-groups', form);
      setShowForm(false);
      setForm(emptyGroup);
      fetchGroups();
    } catch (err) {
      alert('Hata: ' + (err.response?.data?.detail || 'Bilinmeyen hata'));
    }
  };

  const handleDeleteGroup = async (groupId) => {
    if (!window.confirm('Grubu silmek istediğinize emin misiniz?')) return;
    await api.delete(`/api/bom/equivalency-groups/${groupId}`);
    fetchGroups();
  };

  const handleAddMember = async (groupId) => {
    const productId = addMemberProduct[groupId];
    if (!productId) return;
    try {
      await api.post(`/api/bom/equivalency-groups/${groupId}/members`, { product_id: parseInt(productId) });
      setAddMemberProduct({ ...addMemberProduct, [groupId]: '' });
      fetchGroups();
    } catch (err) {
      alert('Hata: ' + (err.response?.data?.detail || 'Bilinmeyen hata'));
    }
  };

  const handleRemoveMember = async (groupId, productId) => {
    await api.delete(`/api/bom/equivalency-groups/${groupId}/members/${productId}`);
    fetchGroups();
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-bold text-gray-800">Eşdeğer Ürünler</h2>
        <button onClick={() => { setForm(emptyGroup); setShowForm(true); }} className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 font-medium text-sm">
          + Yeni Grup
        </button>
      </div>

      {showForm && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-full max-w-md">
            <h3 className="text-lg font-bold mb-4">Yeni Eşdeğerlik Grubu</h3>
            <form onSubmit={handleSubmit}>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Grup Adı *</label>
                <input required value={form.name} onChange={e => setForm({...form, name: e.target.value})} className="w-full border rounded px-3 py-2" />
              </div>
              <div className="mt-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">Not</label>
                <textarea value={form.note} onChange={e => setForm({...form, note: e.target.value})} className="w-full border rounded px-3 py-2" rows={2} />
              </div>
              <div className="flex gap-3 mt-6">
                <button type="submit" className="flex-1 bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700 font-medium">Kaydet</button>
                <button type="button" onClick={() => setShowForm(false)} className="flex-1 bg-gray-100 text-gray-700 py-2 rounded-lg hover:bg-gray-200 font-medium">İptal</button>
              </div>
            </form>
          </div>
        </div>
      )}

      <div className="grid grid-cols-2 gap-4">
        {groups.map(g => {
          const memberIds = new Set(g.members.map(m => m.product_id));
          const candidates = products.filter(p => !memberIds.has(p.id));
          return (
            <div key={g.id} className="bg-white rounded-lg shadow p-4">
              <div className="flex justify-between items-start">
                <div>
                  <h3 className="font-bold text-gray-800">{g.name}</h3>
                  {g.note && <p className="text-xs text-gray-500 mt-1">{g.note}</p>}
                </div>
                <button onClick={() => handleDeleteGroup(g.id)} className="text-red-500 hover:text-red-700 text-sm font-medium">Sil</button>
              </div>

              <ul className="mt-3 divide-y">
                {g.members.map(m => (
                  <li key={m.member_id} className="flex justify-between items-center py-2 text-sm">
                    <span><span className="font-mono text-gray-500 mr-2">{m.product_code}</span>{m.product_name}</span>
                    <button onClick={() => handleRemoveMember(g.id, m.product_id)} className="text-red-500 hover:text-red-700 text-xs font-medium">Çıkar</button>
                  </li>
                ))}
                {g.members.length === 0 && <li className="py-2 text-sm text-gray-400">Henüz üye yok</li>}
              </ul>

              <div className="flex gap-2 mt-3">
                <select value={addMemberProduct[g.id] || ''} onChange={e => setAddMemberProduct({ ...addMemberProduct, [g.id]: e.target.value })} className="flex-1 border rounded px-2 py-1.5 text-sm">
                  <option value="">Ürün seçin</option>
                  {candidates.map(p => <option key={p.id} value={p.id}>{p.code} - {p.name}</option>)}
                </select>
                <button onClick={() => handleAddMember(g.id)} className="bg-gray-100 text-gray-700 px-3 py-1.5 rounded hover:bg-gray-200 text-sm font-medium">Ekle</button>
              </div>
            </div>
          );
        })}
      </div>
      {groups.length === 0 && (
        <div className="text-center py-12 text-gray-400">Henüz eşdeğerlik grubu eklenmemiş</div>
      )}
    </div>
  );
}
